import { EventStatus } from "@finbackoffice/enums";
import { IBetItemData } from "@finbackoffice/fe-core";

export type MultiBetBonusErrorKeys = "min_odds" | "categories";

export const isMinOddsError = (betItems: IBetItemData[], minOdds: number) =>
    betItems.filter((bet) => parseFloat(bet.outcomeValue) < minOdds).length > 0;

export const isCategoryError = (
    betItems: IBetItemData[],
    sportMultiBetCategories: (EventStatus.Prematch | EventStatus.Live)[],
) =>
    betItems.filter(
        (bet) =>
            !sportMultiBetCategories.includes(
                bet.eventStatus as EventStatus.Prematch | EventStatus.Live,
            ),
    ).length > 0;
